import {Form, Formik} from 'formik';
import {makeStyles} from '@mui/styles';
import {Box, Button, Grid} from '@mui/material';

import userIcon from 'assets/img/userIcon2.svg';
import addressIcon from 'assets/img/location.svg';
import phoneIcon from 'assets/img/phoneIcon.svg';
import HouseIcon from 'assets/img/houseIcon.svg';
import styles from 'assets/jss/AgentStyles/DashboardStyle';
import {
  notCenter_ValidationSchema,
  validationSchemaAgent,
} from 'helpers/formValidationSchema';
import FormikField from 'components/Formik/FormikField';
import AutoCompleteField from 'components/Formik/AutoCompleteField';
import useAgentInfo from 'hooks/useAgentInfo';
import useProvince from 'hooks/useProvince';
import useEditAgentProfile from 'hooks/useEditAgentProfile';
import {
  cityOptions,
  findUserLocation,
  provinceOptions,
} from 'helpers/findUserLocation';

const useStyles = makeStyles(styles);

const EditForm = ({handleCloseModal}) => {
  const classes = useStyles();
  const {data: provinceData} = useProvince();
  const {data: AgentInfo} = useAgentInfo();
  const editAgentProfile = useEditAgentProfile();

  const {
    firstName,
    isScanCenter,
    phoneNumber,
    scanCenterAddress,
    lastName,
    userType,
    isMale,
    birthDate,
    yearsWithDiabet,
    insulinType,
    isUsingOralMedications,
    diabetType,
    scanCenterName,
    cityId,
  } = AgentInfo || {};

  const {city: userCityName, province} = findUserLocation(provinceData, cityId);

  const initialValues = isScanCenter
    ? {
        firstName,
        lastName,
        scanCenterName,
        phoneNumber,
        scanCenterAddress,
        cityId: cityId ? {name: userCityName, id: cityId} : null,
        provinceId: province ? {name: province?.name, id: province?.id} : null,
      }
    : {
        firstName,
        lastName,
        phoneNumber,
      };

  const handleSubmit = (values) => {
    const {
      scanCenterAddress,
      firstName,
      lastName,
      cityId,
      scanCenterName
    } = values;

    const agentPutData = {
      firstName,
      lastName,
      scanCenterName,
      scanCenterAddress,
      userType,
      isScanCenter,
      isMale,
      birthDate,
      yearsWithDiabet,
      insulinType,
      isUsingOralMedications,
      diabetType,
      cityId: cityId?.id,
    };
    editAgentProfile.mutate({agentPutData});
    handleCloseModal()
  };

  return (
    <Grid container sx={{placeItems: 'center', mt: '30px'}}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={
          isScanCenter ? validationSchemaAgent : notCenter_ValidationSchema
        }
        onSubmit={handleSubmit}>
        {(props) => {
          return (
            <Box sx={{width: '100%'}}>
              <Form>
                <FormikField
                  {...props}
                  name='firstName'
                  placeholder='نام *'
                  icon={userIcon}
                  type='text'
                />
                <FormikField
                  {...props}
                  name='lastName'
                  placeholder='نام خانوادگی *'
                  icon={userIcon}
                  type='text'
                />
                <FormikField
                  {...props}
                  name='phoneNumber'
                  placeholder='شماره موبایل *'
                  icon={phoneIcon}
                  type='number'
                  disabled
                />
                {isScanCenter && (
                  <>
                    <Grid item xs={12} mb='14px'>
                      <FormikField
                        {...props}
                        name='scanCenterName'
                        placeholder='نام مرکز اسکن *'
                        icon={HouseIcon}
                        type='text'
                      />
                    </Grid>
                    <Grid item xs={12} mb='14px'>
                      <AutoCompleteField
                        options={provinceOptions(provinceData)}
                        {...props}
                        name='provinceId'
                        label='provinceId'
                        placeholder='استان *'
                      />
                    </Grid>
                    <Grid item xs={12} mb='14px'>
                      <AutoCompleteField
                        options={cityOptions(
                          provinceData,
                          props.values.provinceId?.id
                        )}
                        {...props}
                        name='cityId'
                        placeholder='شهر *'
                      />
                    </Grid>
                    <FormikField
                      {...props}
                      type='text'
                      name='scanCenterAddress'
                      placeholder='آدرس'
                      icon={addressIcon}
                    />
                  </>
                )}
                <Button
                  type='submit'
                  variant='contained'
                  className={classes.saveBtn}>
                  ذخیره
                </Button>
              </Form>
            </Box>
          );
        }}
      </Formik>
    </Grid>
  );
};

export default EditForm;
